import React from 'react';
import { FactoryIcon, ClockIcon, ZapIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
interface AvailabilityDeliveryProps {
  onRequestQuote: () => void;
}
export function AvailabilityDelivery({
  onRequestQuote
}: AvailabilityDeliveryProps) {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  return <section className="py-20 bg-dark-bg border-y border-dark-border" data-id="element-143" data-mp="3rn9g9b4hikfh">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144" data-mp="8lh3c7kjocz">
        <div className="text-center mb-10" data-id="element-145" data-mp="a6cf41pjbbw">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3" data-id="element-146" data-mp="3hpv8dzwmn3ys">
            {en ? <>
                Availability and{' '}
                <span className="text-brand-yellow" data-id="element-147" data-mp="3mopsr6a8t0l0">delivery</span>
              </> : ru ? <>
                Наличие и <span className="text-brand-yellow" data-id="element-148" data-mp="3cq0gpu512aco">доставка</span>
              </> : <>
                Dostupnost i <span className="text-brand-yellow" data-id="element-149" data-mp="3ghork0ipfx37">isporuka</span>
              </>}
          </h2>
        </div>

        <div className="bg-dark-surface border border-dark-border rounded-industrial p-6 md:p-8 mb-8" data-id="element-150" data-mp="3bjdl7zrmc4pq">
          <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-151" data-mp="3qg4ju6tgxcea">
            {en ? <>
                Models available from stock can be delivered{' '}
                <span className="text-brand-yellow font-bold" data-id="element-152" data-mp="2xsqk60ydy2qh">the same day</span>
                . For models made to order, the standard lead time for delivery
                directly from production (with a guaranteed maximum capacity of
                a new battery) is{' '}
                <span className="text-brand-yellow font-bold" data-id="element-153" data-mp="32qaa3y4g43y9">4–6 weeks</span>.
              </> : ru ? <>
                Модели, имеющиеся на складе, могут быть отправлены{' '}
                <span className="text-brand-yellow font-bold" data-id="element-154" data-mp="2a1uzdnsck7sq">
                  в тот же день
                </span>
                . Для моделей под заказ стандартный срок поставки напрямую с
                производства (с гарантированной максимальной ёмкостью новой
                батареи) составляет{' '}
                <span className="text-brand-yellow font-bold" data-id="element-155" data-mp="38jn39qcd5p5o">4–6 недель</span>.
              </> : <>
                Modeli koji su na lageru isporučuju se{' '}
                <span className="text-brand-yellow font-bold" data-id="element-156" data-mp="2gticn9y0g5w0">istog dana</span>.
                Za modele po narudžbini, standardni rok isporuke direktno iz
                proizvodnje (uz garantovan maksimalni kapacitet nove baterije)
                iznosi{' '}
                <span className="text-brand-yellow font-bold" data-id="element-157" data-mp="2us8cgxc7sjo2">4–6 nedelja</span>
                .
              </>}
          </p>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed mt-4" data-id="element-158" data-mp="51vawaubf36y">
            {en ? <>
                Contact us for{' '}
                <span className="text-white font-semibold" data-id="element-159" data-mp="1uk1xo1kliino">
                  current availability and reservations
                </span>
                .
              </> : ru ? <>
                Свяжитесь с нами для уточнения{' '}
                <span className="text-white font-semibold" data-id="element-160" data-mp="1krcml7syj6sv">
                  актуального наличия и бронирования
                </span>
                .
              </> : <>
                Kontaktirajte nas za{' '}
                <span className="text-white font-semibold" data-id="element-161" data-mp="16swdxbbjb683">
                  trenutno stanje i rezervaciju
                </span>
                .
              </>}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-162" data-mp="wx1rs683qt0k">
          <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/60 rounded-industrial p-4" data-id="element-163" data-mp="2w9dywxeatigr">
            <FactoryIcon className="w-6 h-6 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-164" data-mp="2rau9uo4erqk6" />
            <div data-id="element-165" data-mp="2za7fh8tu0kxm">
              <p className="text-white font-semibold text-sm mb-1" data-id="element-166" data-mp="2zbs7aqorhprs">
                {en ? 'Direct from production' : ru ? 'Напрямую с производства' : 'Direktno iz proizvodnje'}
              </p>
              <p className="text-gray-400 text-xs" data-id="element-167" data-mp="2uaupwgbkszrc">
                {en ? 'Maximum battery capacity, full motor power.' : ru ? 'Максимальная ёмкость аккумулятора, полная мощность мотора.' : 'Maksimalni kapacitet baterije, puna snaga motora.'}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/60 rounded-industrial p-4" data-id="element-168" data-mp="26jyt14s9jed8">
            <ClockIcon className="w-6 h-6 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-169" data-mp="1xklhm6kkwfpv" />
            <div data-id="element-170" data-mp="21mp4rsgm18qz">
              <p className="text-white font-semibold text-sm mb-1" data-id="element-171" data-mp="21n8cyhggkirt">
                {en ? 'Same day or 4–6 weeks' : ru ? 'В тот же день или 4–6 недель' : 'Isti dan ili 4–6 nedelja'}
              </p>
              <p className="text-gray-400 text-xs" data-id="element-172" data-mp="1rz32iow3jxi0">
                {en ? 'From stock, or made to order.' : ru ? 'Со склада или под заказ.' : 'Sa lagera ili po narudžbini.'}
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/60 rounded-industrial p-4" data-id="element-173" data-mp="1wy7a5b3dhn68">
            <ZapIcon className="w-6 h-6 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-174" data-mp="2aq43figs2347" />
            <div data-id="element-175" data-mp="26o9068fadfns">
              <p className="text-white font-semibold text-sm mb-1" data-id="element-176" data-mp="26nquymanbr3q">
                {en ? 'Quick response' : ru ? 'Быстрый ответ' : 'Brz odgovor'}
              </p>
              <p className="text-gray-400 text-xs" data-id="element-177" data-mp="2klfenqsz8s77">
                {en ? 'We reply to all inquiries within 24h.' : ru ? 'Отвечаем на все запросы в течение 24 ч.' : 'Odgovaramo na sve upite u roku od 24h.'}
              </p>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-178" data-mp="1mawcze4ey8bl">
          <Button variant="primary" size="lg" onClick={onRequestQuote} data-id="element-179" data-mp="1m9ursgtoo5g5">
            {en ? 'Check availability' : ru ? 'Проверить наличие' : 'Proverite dostupnost'}
          </Button>
        </div>
      </div>
    </section>;
}